import Vue from 'vue'
import Vuex from 'vuex'

import provinces from './provinces/'
import jsonLD from './jsonld'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    test: 'test',
    provinces,
    phone: '1 (800) 813-6084',
    email: 'service@navlegal.com',
    jsonLD,
    meta: {
      description: '',
      keywords: '',
      title: '',
      image: '',
      url: '',
      defaults: {
        description:
          'NavLegal provides affordable, trusted, and certified notary public and commissioner for oaths services across Canada. Our services include notarizing documents, commissioning documents, providing certified true copies, and more. Call us today to book your appointment. Same day appointments are available at most of our locations',
        keywords:
          'NavLegal,notary,public,notary public,notary service,notaries,commissioner,oaths,certified,true,copies,notarizing,affordable,appointments,Canada',
        title: 'NavLegal Notaries | Certified. Trusted. Affordable.',
        image: 'https://www.navlegalnotaries.com/static/notary.jpg',
        url: 'https://www.navlegalnotaries.com'
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js